<script lang="ts">
  import {dialogData} from "$lib/stores/dialogStores";
  import {onMount} from "svelte";

  let data = {};

  dialogData.subscribe(value => {
    data = value.PaymentIqIframe;
  });

  onMount(() => {
    initPayment(data);
  });

  function initPayment(data: any) {
    let CashierInstance = new _PaymentIQCashier('#cashier',
      {
        ...data,
        theme: {
          headings: {
            color: "#fff"
          },
          background: {
            color: "#1c2535"
          },
          cashierbackground: {
            color: "#1c2535"
          },
          buttons: {
            color: "#F93B2B",
          },
        }
      },
      (api: any) => {
        api.on({
          update: (data: any) => console.log('The passed in data was set', data),
          success: (data: any) => console.log('Transaction was completed successfully', data),
          failure: (data: any) => console.log('Transaction failed', data),
          isLoading: (data: any) => console.log('Data is loading', data),
          doneLoading: (data: any) => {console.log('Data has been successfully downloaded', data)
          },
          newProviderWindow: (data: any) => console.log('A new window / iframe has opened', data)
        }),
          api.css(``)
      })
  }

</script>

<div class="w-full min-h-80 py-2">
  <div id="cashier"></div>
</div>
